import { render, staticRenderFns } from "./ExamInsightContent.vue?vue&type=template&id=2312a81d"
import script from "./ExamInsightContent.vue?vue&type=script&lang=js"
export * from "./ExamInsightContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports